import { NgModule } from '@angular/core';
import { LoginComponent } from 'src/app/features/authentication/components/login/login.component';
import { ForgotPasswordStep1Component } from 'src/app/features/authentication/components/forgot-password-step1/forgot-password-step1.component';
import { ForgotPasswordStep2Component } from 'src/app/features/authentication/components/forgot-password-step2/forgot-password-step2.component';
import { RegisterComponent } from 'src/app/features/authentication/components/register/register.component';
import { ThankYouPageComponent } from 'src/app/features/authentication/components/thank-you-page/thank-you-page.component';
import { RouterModule, Routes } from '@angular/router';
import { ResendVerificationEmailComponent } from 'src/app/features/authentication/components/resend-verification-email/resend-verification-email.component';
import { RegisterStep1Component } from './components/register-step1/register-step1.component';

const AUTHENTICATION_ROUTES: Routes = [
  { path: '', redirectTo: '/auth/login', pathMatch: 'full' },
  {
    path: 'login',
    component: LoginComponent /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'login/:email',
    component: LoginComponent /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'autologin/:login_token',
    component: LoginComponent /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'forgotpassword',
    component: ForgotPasswordStep1Component /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'forgotpassword/:email',
    component: ForgotPasswordStep2Component /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'registerStep1',
    component: RegisterStep1Component /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'registerStep2',
    component: RegisterComponent /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'registerStep2/:email',
    component: RegisterComponent /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'resendverificationemail',
    component: ResendVerificationEmailComponent /*, canActivate: [PublicGuard]  */,
  },
  {
    path: 'thankyou',
    component: ThankYouPageComponent /*, canActivate: [PublicGuard]  */,
  },
];

@NgModule({
  imports: [RouterModule.forChild(AUTHENTICATION_ROUTES)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
